/**
 * @file        src/api/insurance.js
 * @description Travel-insurance client for the admin console — the twin of
 *              api/flightBookings.js and api/hotelBookings.js.
 *
 *              The Insurance screens read through ReadOnlyListPage and raw
 *              `get()` calls, so this file exists for the ACTIONS: everything
 *              that is a POST/PATCH and therefore has a body worth naming in one
 *              place rather than spelling a URL at each call site.
 * @author      Kinetika Labs
 * @created     2026-09-25
 * @changelog
 *   - 2026-09-25 Claude — Initial (Share by Email). See CLAUDE.md §28.
 */
import { get, post } from './client';

/** One standalone policy, with its supplier payload and invoice number. */
export const getBooking = (id) => get(`/insurance/bookings/${id}`);

/**
 * Email the Tax Invoice, the insurer's Policy Document, or both.
 *
 * Only the INVOICE travels in this body — ShareEmailModal rasterizes the admin's
 * own InvoiceDoc page and posts it as base64, exactly as the flight and hotel
 * shares do. The policy document is already a PDF on the server's disk, so the
 * server attaches it from there; sending `document: 'policy'` alone therefore
 * carries no attachments at all.
 */
export const shareByEmail = (id, body) =>
  post(`/insurance/bookings/${id}/share-email`, body);
